import React from "react";

const AboutMe = () => {
    return (
        <div className="about-me">
            <h1 className="my-name">Lior Kashi</h1>
            <p className="bio">
                I am a passionate developer with a strong foundation in Computer Science. <br />
                I love turning ideas into real impactful products using code.
                My goal is to make a difference through technology—building solutions that truly help people and
                create value.
            </p>
        </div>
    );
};

export default AboutMe;
